import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, InputAdornment, TextField, Popover } from '@material-ui/core';
import { Autocomplete } from "@material-ui/lab";
import { cloneDeep } from "lodash-es";
import { FC, useEffect, useRef, useState } from "react";
import { QuickLinkGroup } from '../../api/dtos';
import { SketchPicker } from 'react-color';
import { faTimes } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
interface IGroupEdit {
  group: QuickLinkGroup;
  open: boolean;
  onOk: (group: QuickLinkGroup) => void;
  onClose: () => void;
  adGroups: string[];
}
const GroupEdit: FC<IGroupEdit> = ({
  open,
  onClose,
  group,
  onOk,
  adGroups: groups
}) => {
  const [editGroup, setEditGroup] = useState<QuickLinkGroup>({} as any);
  useEffect(() => {
    if (open) {
      setEditGroup(cloneDeep(group));
    }
  }, [open, group]);
  const [showColor, setShowColor] = useState(false);
  const elementRef = useRef<HTMLDivElement>();
  return <Dialog open={open} onClose={onClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" data-sentry-element="Dialog" data-sentry-component="GroupEdit" data-sentry-source-file="GroupEdit.tsx">
            <DialogTitle id="alert-dialog-title" data-sentry-element="DialogTitle" data-sentry-source-file="GroupEdit.tsx">Edit Group Configuration</DialogTitle>
            <DialogContent data-sentry-element="DialogContent" data-sentry-source-file="GroupEdit.tsx">
                <DialogContentText id="alert-dialog-description" data-sentry-element="DialogContentText" data-sentry-source-file="GroupEdit.tsx">
                    <TextField label="Title" fullWidth InputLabelProps={{
          shrink: true
        }} margin="normal" value={editGroup.name ?? ''} onChange={e => {
          setEditGroup(c => ({
            ...c,
            name: e.target.value && e.target.value !== '' ? e.target.value : undefined as any
          }));
        }} data-sentry-element="TextField" data-sentry-source-file="GroupEdit.tsx" />
                    <TextField label="Color" fullWidth InputLabelProps={{
          shrink: true
        }} margin="normal" value={editGroup.color ?? ''} inputProps={{
          readOnly: true
        }} onClick={() => setShowColor(true)} InputProps={{
          startAdornment: <InputAdornment position="start">
                                    <div ref={elementRef as any} style={{
              height: 32,
              width: 32,
              background: editGroup.color,
              border: `1px solid lightgray`
            }} onClick={() => setShowColor(true)} />
                                </InputAdornment>,
          endAdornment: <InputAdornment position="end">
                                    <IconButton style={{
              padding: 0,
              visibility: editGroup.color ? 'visible' : 'hidden'
            }} onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              setEditGroup(c => ({
                ...c,
                color: undefined as any
              }));
            }}>
                                        <FontAwesomeIcon icon={faTimes} fixedWidth />
                                    </IconButton>
                                </InputAdornment>
        }} data-sentry-element="TextField" data-sentry-source-file="GroupEdit.tsx" />
                    <Popover id={'edit.color'} open={!!elementRef.current && showColor} anchorEl={elementRef.current} onClose={() => setShowColor(false)} style={{
          width: 300
        }} anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }} transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }} data-sentry-element="Popover" data-sentry-source-file="GroupEdit.tsx">
                        {/* <ClickAwayListener onClickAway={() => setShowColor(false)}> */}
                        <SketchPicker color={editGroup.color} onChange={e => {
            setEditGroup(c => ({
              ...c,
              color: e.hex
            }));
          }} presetColors={["#004842", "#cd1342"]} data-sentry-element="SketchPicker" data-sentry-source-file="GroupEdit.tsx" />
                        {/* </ClickAwayListener> */}
                    </Popover>
                    <TextField label="Enabled" fullWidth InputLabelProps={{
          shrink: true
        }} margin="normal" InputProps={{
          startAdornment: <InputAdornment position="start">
                                    <Checkbox checked={editGroup.enabled} onChange={(e, checked) => {
              setEditGroup(c => ({
                ...c,
                enabled: checked
              }));
            }} />
                                </InputAdornment>
        }} value={editGroup.enabled ? "Enabled" : "Disabled"} data-sentry-element="TextField" data-sentry-source-file="GroupEdit.tsx" />
                    <Autocomplete multiple id="tags-standard" options={groups} value={editGroup.adGroups} onChange={(event, newValue) => {
          setEditGroup(c => ({
            ...c,
            adGroups: newValue
          }));
        }} renderInput={params => <TextField {...params} InputLabelProps={{
          shrink: true
        }} variant="standard" margin="normal" label="Restricted To" helperText="AD Groups - Any of the above groups give access" />} data-sentry-element="Autocomplete" data-sentry-source-file="GroupEdit.tsx" />
                </DialogContentText>
            </DialogContent>
            <DialogActions data-sentry-element="DialogActions" data-sentry-source-file="GroupEdit.tsx">
                <Button onClick={onClose} color="secondary" data-sentry-element="Button" data-sentry-source-file="GroupEdit.tsx">
                    Cancel
                </Button>
                <Button onClick={() => {
        onOk(editGroup);
        onClose();
      }} color="primary" autoFocus data-sentry-element="Button" data-sentry-source-file="GroupEdit.tsx">
                    Ok
                </Button>
            </DialogActions>
        </Dialog>;
};
export default GroupEdit;